import { useSeo } from "@/lib/useSeo";
import { PageHero, SectionHeading } from "@/components/site/kit";
import { ProductGrid } from "@/components/site/ProductCard";
import { CtaBanner } from "@/components/site/Sections";

export default function Products() {
  useSeo({ title: "Ready-made Software Products", description: "LeadMachine, AI Accountants, Real Estate CRM, Medical CRM, WhatsApp automation and more, ready-made software for Indian businesses." });
  return (
    <>
      <PageHero badge="Our products" title="Ready-made software," highlight="branded as your own" subtitle="Battle-tested products for lead generation, CRM, accounting, healthcare and automation. Get a live demo and go live in days, not months." />
      <section className="section bg-page">
        <div className="container-x">
          <ProductGrid />
        </div>
      </section>
      <section className="section bg-white">
        <div className="container-x">
          <SectionHeading title="Need something" highlight="unique?" subtitle="Every product can be customised, or we can build one from scratch around your workflow." center />
          <CtaBanner title="Want a custom version?" subtitle="Tell us your requirements and get a free consultation." button="Get a Free Quote" />
        </div>
      </section>
    </>
  );
}
